<!--表格的配置, 包含列配置、操作按钮配置-->
<template>
  <ElButton :icon="IconSetting" class="setting-btn" @click="showTableConfig">{{
    title
  }}</ElButton>
</template>

<script setup lang="ts">
import { TableCtx, CmdbarApi } from '../types';
import { useShareData } from '../../core/SharedData';
import { showDrawer } from '../../core/EasyPopup';
import { IconSetting } from '../Icons';
import TableConfigDrawer from './TableConfigDrawer.vue';
const props = defineProps<{
  showCmdConfig?: boolean; // 是否显示命令配置
}>();

const tableCtx = useShareData('table', 'ctx') as TableCtx;

// 标记有列表配置, 用于控制列是否可调整
useShareData('table', 'setting').$('showColumnConfig')(true);

const cmdbarApi = useShareData('cmdbar', 'setting') as CmdbarApi;

// 是否有菜单按钮
const hasCmds = cmdbarApi.cmdLabelMap().length > 0;

// 按钮文字
const title = props.showCmdConfig && hasCmds ? '列表设置' : '列设置';

async function showTableConfig() {
  await showDrawer(
    TableConfigDrawer,
    {
      showCmdConfig: props.showCmdConfig,
      tableCtx,
      cmdbarApi
    },
    { defaultFooter: false, title, closeOnClickModal: true }
  );
}
</script>

<style lang="scss" scoped>
.setting-btn {
  color: #606266;
  border: none;
  background-color: transparent;
}

.setting-btn:hover {
  color: #606266;
  background-color: #f4f6f9;
}
</style>
